<ng-container *ngIf="machines != null && machines.length > 0">
  <app-card-carousel header="More From This Owner" cardComponentName="MachineCardAdvancedComponent"
    [slidesPerViewConfig]="slidesPerViewConfig" [cardData]="machines">
  </app-card-carousel>
</ng-container>